import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = { primary: '#8B1A1A', gold: '#D4A017', bg: '#FFF8F0' };

export default function About() {
  const navigate = useNavigate();

  return (
    <div>
      <div style={{ background: 'linear-gradient(135deg, #8B1A1A 0%, #6B0F0F 100%)', padding: '60px 24px', textAlign: 'center' }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 42, color: '#fff', marginBottom: 16 }}>Our Story</h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 17, maxWidth: 600, margin: '0 auto' }}>
          Fashion is more than just style — it's a statement
        </p>
      </div>

      <div style={{ maxWidth: 900, margin: '0 auto', padding: '60px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 40, marginBottom: 60 }}>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: '#2C2C2C', marginBottom: 16 }}>Who We Are</h2>
            <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15 }}>
              A1 Looks was born from a deep love for India's rich craft heritage. We celebrate the artisans who pour their heart into every stitch, every bead, and every embroidery — bringing their work to fashion-conscious women across India.
            </p>
            <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15, marginTop: 12 }}>
              From the vibrant Phulkari embroidery of Punjab to the delicate Kundan jewellery of Rajasthan, we curate pieces that are as unique as you are.
            </p>
          </div>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: '#2C2C2C', marginBottom: 16 }}>Our Mission</h2>
            <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15 }}>
              We believe that handcrafted ethnic fashion should be accessible to every woman who wants to express her identity through clothing and accessories. Our mission is to bridge the gap between master artisans and modern shoppers.
            </p>
          </div>
        </div>

        <div style={{ background: C.bg, borderRadius: 12, padding: '40px', marginBottom: 48, border: '1px solid #f0e0e0' }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 26, color: '#2C2C2C', marginBottom: 24, textAlign: 'center' }}>Why Choose A1 Looks?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 24 }}>
            {[
              { icon: '🤝', title: 'Artisan Made', desc: 'Every piece handcrafted by skilled artisans' },
              { icon: '✨', title: 'Authentic Designs', desc: 'Rooted in Indian craft traditions' },
              { icon: '🚚', title: 'Fast Delivery', desc: 'Ships across India in 3–7 days' },
            ].map(item => (
              <div key={item.title} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 36, marginBottom: 10 }}>{item.icon}</div>
                <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 16, color: '#2C2C2C', marginBottom: 6 }}>{item.title}</h3>
                <p style={{ fontSize: 13, color: '#888', lineHeight: 1.5 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 32 }}>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: '#2C2C2C', marginBottom: 16 }}>Contact Us</h2>
            <p style={{ color: '#555', lineHeight: 2, fontSize: 14 }}>
              📍 Neo Town Road, Bangalore 560100<br />
              📞 +91 7042544844<br />
              ✉️ rohini@A1looks.com
            </p>
          </div>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: '#2C2C2C', marginBottom: 16 }}>Business Hours</h2>
            <p style={{ color: '#555', lineHeight: 2, fontSize: 14 }}>
              Monday – Saturday: 10 AM – 7 PM IST<br />
              Sunday: 11 AM – 5 PM IST<br />
              <br />
              Orders placed after 5 PM will be processed the next business day.
            </p>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 48 }}>
          <button
            onClick={() => navigate('/shop')}
            style={{ background: C.primary, color: '#fff', border: 'none', padding: '14px 36px', fontSize: 15, fontWeight: 700, borderRadius: 4, cursor: 'pointer' }}
          >
            Explore Our Collection
          </button>
        </div>
      </div>
    </div>
  );
}
